import {
  collection,
  doc,
  getDoc,
  setDoc,
  updateDoc,
  getDocs,
  serverTimestamp,
  deleteDoc,
} from 'firebase/firestore';
import { getFirestoreInstance } from './firestore';
import type { Client } from '@gigdriver/domain';
import { fromFirestore } from './serde';

function clientsCollection(orgId: string) {
  return collection(getFirestoreInstance(), 'organizations', orgId, 'clients');
}

export async function createClient(
  orgId: string,
  client: Omit<Client, 'id' | 'orgId' | 'createdAt' | 'updatedAt'>,
): Promise<string> {
  const clientRef = doc(clientsCollection(orgId));
  const clientId = clientRef.id;

  await setDoc(clientRef, {
    ...client,
    id: clientId,
    orgId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });

  return clientId;
}

export async function getClient(orgId: string, clientId: string): Promise<Client | null> {
  const clientRef = doc(getFirestoreInstance(), 'organizations', orgId, 'clients', clientId);
  const docSnap = await getDoc(clientRef);
  return docSnap.exists() ? fromFirestore<Client>(docSnap.data()) : null;
}

export async function getOrgClients(orgId: string): Promise<Client[]> {
  const snapshot = await getDocs(clientsCollection(orgId));
  return snapshot.docs.map(d => fromFirestore<Client>(d.data()));
}

export async function updateClient(
  orgId: string,
  clientId: string,
  updates: Partial<Client>,
): Promise<void> {
  const clientRef = doc(getFirestoreInstance(), 'organizations', orgId, 'clients', clientId);
  await updateDoc(clientRef, {
    ...updates,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteClient(orgId: string, clientId: string): Promise<void> {
  const clientRef = doc(getFirestoreInstance(), 'organizations', orgId, 'clients', clientId);
  await deleteDoc(clientRef);
}
